import { route } from '@/ziggy-shim';
import { api } from './LaravelClient';

export default {
  async index(projectId: Id) {
    return await api(route('api.v1.report-sections.index', projectId), 'get');
  },

  async show(reportSectionId: Id) {
    return await api(route('api.v1.admin.report-sections.show', reportSectionId), 'get');
  },

  admin: {
    async seed() {
      return await api(route('api.v1.admin.report-sections.seed'), 'post');
    },

    async index() {
      return await api(route('api.v1.admin.report-sections.index'), 'get');
    },
  },
};
